export { InlineEdit } from './inline-edit';
export type { InlineEditProps } from './inline-edit';
